import React from "react";
import "./index.css";
import Menu from "../../Components/Menu";
import { Link, useNavigate } from "react-router-dom";
import voltar from "../../assets/images/png/voltar.png";

export default function ComoFuncionaLibertadores() {
  const navigate = useNavigate();
  return (
    <div className="w-100">
      <div className="imgBackground"></div>
      <Menu />

      {/* Cabeçalho */}
      <div className="px-3">
        <div
          className="position-relative"
          style={{ marginTop: 5, fontSize: 22, marginBottom: 20 }}
        >
          <div className="d-flex justify-content-center mt-3">
            <div
              className="d-flex justify-content-start w-100"
              style={{ maxWidth: 500, padding: "0 0 0 15px" }}
            >
              <Link to="/home">
                <img className="imgVoltarLogado" src={voltar} alt="Voltar" />
              </Link>
              <div className="tituloLogado">Como funciona</div>
            </div>
          </div>
        </div>
        <br />
      </div>
      <div className="d-flex justify-content-center">
        <div style={{ maxWidth: 500, padding: "0 0px" }}>
          <h2 className="regulamento-titulo">
            Campanha Libertadores - Regulamento
          </h2>

          <div className="regulamento-conteudo">
            <ul className="regulamento-lista">
              <li>
                Esta campanha computará pontos exclusivamente para a premiacão
                descrita, não sendo possível a troca por qualquer outro produto
                ou servico;
              </li>

              <li>
                Para que os pontos passem a ser computados, cada elegível
                precisará estar cadastrado no Centro de Treinamento;
              </li>

              <li>
                Para a computação das vendas por vendedor, serão consideradas as
                informações de acordo com o DMS da Concessionária;
              </li>

              <li>
                Somente Vendedores com cadastro de Vendedor de veiculos novos no
                Centro de Treinamento receberão a pontuacão;
              </li>

              <li>
                Nao é possivel a troca de pontos e premiação entre
                participantes;
              </li>

              <li>
                Caso vencedor abdique do prêmio, o mesmo será direcionado para o
                próximo participante que apresentar maior pontuação;
              </li>

              <li>
                Cada Vendedor receberá a pontuacão correspondente ao volume,
                modelo dos veículos vendidos (varejados) no período entre
                01/07/2025 e 15/08/2025;
              </li>

              <li>
                Somente veículos do estoque do concessionário que forem
                varejados no período serão considerados, exceto Kona faturados
                como Special Direct Sale;
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row d-flex justify-content-center w-100">
        <div className="col-md-3 my-3">
          <button
            style={{
              width: "100%",
              backgroundColor: "#00aad2",
              borderRadius: 50,
              color: "#fff",
              outline: "none",
              border: "#00aad2",
              padding: "10px 20px",
            }}
            onClick={() => navigate("/ranking-libertadores")}
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  );
}
